export const valueRelationByApi = {
  truecaller: 'HAS_TRUECALLER',
  'Companies House Search Officers by Phrase':
    'HAS_COMPANIES_HOUSE_SEARCH_OFFICERS_BY_PHRASE',
  'Instagram Get Entity by ID or Alias or URL or Code':
    'HAS_INSTAGRAM_GET_ENTITY_BY_ID_OR_ALIAS_OR_URL_OR_CODE',
  'Facebook Search Users by Different Parameters':
    'HAS_FACEBOOK_SEARCH_USERS_BY_DIFFERENT_PARAMETERS',
  persona: 'HAS_PERSONA',
  telefono: 'HAS_TELEFONO',
  compania: 'HAS_COMPANIA',
};
